import { render, staticRenderFns } from "./UserMasterTable.vue?vue&type=template&id=af0643e8"
import script from "./UserMasterTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserMasterTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports